import React from "react";

export default function EmailIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3 4H3.7C2.76112 4 2 4.76112 2 5.7V14.3C2 15.2389 2.76112 16 3.7 16H16.3C17.2389 16 18 15.2389 18 14.3V5.7C18 4.76112 17.2389 4 16.3 4ZM16.6 14.3C16.6 14.3796 16.5684 14.4559 16.5121 14.5121C16.4559 14.5684 16.3796 14.6 16.3 14.6H3.69999C3.53431 14.6 3.39999 14.4657 3.39999 14.3V5.7C3.39999 5.53431 3.53431 5.4 3.69999 5.4H16.3C16.4657 5.4 16.6 5.53431 16.6 5.7V14.3ZM16.0051 7.44183C16.0413 7.25166 15.9959 7.05506 15.88 6.9C15.775 6.74742 15.6131 6.64345 15.4307 6.61147C15.2482 6.5795 15.0606 6.62221 14.91 6.73L10.18 9.94C10.0799 10.0059 9.95012 10.0059 9.85 9.94L5.09 6.72C4.88457 6.58066 4.62041 6.56151 4.39703 6.66975C4.17365 6.77799 4.02499 6.99717 4.00703 7.24475C3.98908 7.49232 4.10457 7.73066 4.31 7.87L9.09 11.09C9.66383 11.49 10.4262 11.49 11 11.09L15.69 7.9C15.8547 7.79824 15.969 7.63199 16.0051 7.44183Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
